/**
 * Serialises a plain object into a URL query string. Omits null, undefined,
 * and empty string values (same behaviour as Fortify backoffice `utils/helper`).
 *
 * @param {Record<string, unknown>} [filters={}]
 * @returns {string}
 */
export function buildQueryString(filters = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== null && item !== undefined && item !== "") {
          searchParams.append(key, item);
        }
      });
      return;
    }

    searchParams.append(key, String(value));
  });

  return searchParams.toString();
}
